export default "<div class=\"text-center\">\r\n    <img src=\"assets\\images\\not-found.jpg\" alt=\"\">\r\n</div>"